export var ChannelType;
(function (ChannelType) {
    ChannelType["PUBLIC"] = "PUBLIC";
    ChannelType["PRIVATE"] = "PRIVATE";
})(ChannelType || (ChannelType = {}));
export var ChannelMemberRole;
(function (ChannelMemberRole) {
    ChannelMemberRole["OWNER"] = "OWNER";
    ChannelMemberRole["MEMBER"] = "MEMBER";
})(ChannelMemberRole || (ChannelMemberRole = {}));
export var UserPresenceStatus;
(function (UserPresenceStatus) {
    UserPresenceStatus["ONLINE"] = "ONLINE";
    UserPresenceStatus["OFFLINE"] = "OFFLINE";
    UserPresenceStatus["AWAY"] = "AWAY";
    UserPresenceStatus["BUSY"] = "BUSY";
})(UserPresenceStatus || (UserPresenceStatus = {}));
